/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_CoreInputs */

const en_us2_catalog_movement_core = /** @type {(inputs: Catalog_Movement_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Core`)
};

const pt_br2_catalog_movement_core = /** @type {(inputs: Catalog_Movement_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abdômen`)
};

const es_419_catalog_movement_core = /** @type {(inputs: Catalog_Movement_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Core`)
};

const pt_pt2_catalog_movement_core = /** @type {(inputs: Catalog_Movement_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abdómen`)
};

const fr_fr2_catalog_movement_core = /** @type {(inputs: Catalog_Movement_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tronc`)
};

const de_de2_catalog_movement_core = /** @type {(inputs: Catalog_Movement_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rumpf`)
};

const it_it2_catalog_movement_core = /** @type {(inputs: Catalog_Movement_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Addome`)
};

/**
* | output |
* | --- |
* | "Core" |
*
* @param {Catalog_Movement_CoreInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_core = /** @type {((inputs?: Catalog_Movement_CoreInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_CoreInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_core(inputs)
	if (locale === "es-419") return es_419_catalog_movement_core(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_core(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_core(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_core(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_core(inputs)
	return en_us2_catalog_movement_core(inputs)
});
export { catalog_movement_core as "catalog.movement.core" }